import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: '',
});

// Function to refresh the JWT token

// Attach the access token to the request headers
axiosInstance.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add a response interceptor to handle token expiration
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && error.response.status === 401) {
      // Token expired or unauthorized, attempt to refresh the token
      // await refreshAccessToken()

      localStorage.removeItem('accessToken');
      localStorage.removeItem('role');
      window.location.href = '/login';
      return axiosInstance(error.config);
    }

    // If the refresh token fails or another error occurs, handle it here
    return Promise.reject(error);
  }
);

export default axiosInstance;
